// @flow
import { bindActionCreators } from 'redux';
import store from './index';
import { actionCreators as authActions, type AuthActionCreators } from './modules/auth';
import { actionCreators as userActions, type UserActionCreators } from './modules/user';
import { actionCreators as baseActions, type BaseActionCreators } from './modules/base';
import { actionCreators as writeActions, type WriteActionCreators } from './modules/write';
import { actionCreators as sampleActions, type SampleActionCreators } from './modules/sample';

import { actionCreators as postsActions, type PostsActionCreators } from './modules/posts';
import { actionCreators as productsActions, type ProductsActionCreators } from './modules/products';
import { actionCreators as profileActions, type ProfileActionCreators } from './modules/profile';
import { actionCreators as bannersActions, type BannersActionCreators } from './modules/banners';
import { actionCreators as brandsActions, type BrandsActionCreators } from './modules/brands';
import { actionCreators as eventsActions, type EventsActionCreators } from './modules/events';
import { actionCreators as lettersActions, type LettersActionCreators } from './modules/letters';
import { actionCreators as quotesActions, type QuotesActionCreators } from './modules/quotes';
import { actionCreators as partnersActions, type PartnersActionCreators } from './modules/partners';

import { actionCreators as listingActions, type ListingActionCreators } from './modules/listing';
import { actionCreators as displayActions, type DisplayActionCreators } from './modules/display';
import { actionCreators as banneringActions, type BanneringActionCreators } from './modules/bannering';
import { actionCreators as brandingActions, type BrandingActionCreators } from './modules/branding';
import { actionCreators as eventingActions, type EventingActionCreators } from './modules/eventing';
import { actionCreators as letteringActions, type LetteringActionCreators } from './modules/lettering';
import { actionCreators as quotingActions, type QuotingActionCreators } from './modules/quoting';
import { actionCreators as partneringActions, type PartneringActionCreators } from './modules/partnering';

import { actionCreators as followActions } from './modules/follow';
import { actionCreators as commonActions } from './modules/common';
import { actionCreators as settingsActions } from './modules/settings';
import { actionCreators as estimateActions } from './modules/estimate';
import { actionCreators as searchActions } from './modules/search';
import { actionCreators as seriesActions } from './modules/series';
import { actionCreators as cartActions } from './modules/cart';
import { actionCreators as wishActions } from './modules/wish';
import { actionCreators as ordersActions } from './modules/orders';

const { dispatch } = store;

export const AuthActions: AuthActionCreators = bindActionCreators(authActions, dispatch);
export const UserActions: UserActionCreators = bindActionCreators(userActions, dispatch);
export const BaseActions: BaseActionCreators = bindActionCreators(baseActions, dispatch);
export const WriteActions: WriteActionCreators = bindActionCreators(writeActions, dispatch);
export const SampleActions: SampleActionCreators = bindActionCreators(sampleActions, dispatch);

export const PostsActions: PostsActionCreators = bindActionCreators(postsActions, dispatch);
export const ProductsActions: ProductsActionCreators = bindActionCreators(productsActions, dispatch);
export const BannersActions: BannersActionCreators = bindActionCreators(bannersActions, dispatch);
export const BrandsActions: BrandsActionCreators = bindActionCreators(brandsActions, dispatch);
export const EventsActions: EventsActionCreators = bindActionCreators(eventsActions, dispatch);
export const LettersActions: LettersActionCreators = bindActionCreators(lettersActions, dispatch);
export const QuotesActions: QuotesActionCreators = bindActionCreators(quotesActions, dispatch);
export const PartnersActions: PartnersActionCreators = bindActionCreators(partnersActions, dispatch);

export const ListingActions: ListingActionCreators = bindActionCreators(listingActions, dispatch);
export const DisplayActions: DisplayActionCreators = bindActionCreators(displayActions, dispatch);
export const BanneringActions: BanneringActionCreators = bindActionCreators(banneringActions, dispatch);
export const BrandingActions: BrandingActionCreators = bindActionCreators(brandingActions, dispatch);
export const EventingActions: EventingActionCreators = bindActionCreators(eventingActions, dispatch);
export const LetteringActions: LetteringActionCreators = bindActionCreators(letteringActions, dispatch);
export const QuotingActions: QuotingActionCreators = bindActionCreators(quotingActions, dispatch);
export const PartneringActions: PartneringActionCreators = bindActionCreators(partneringActions, dispatch);

export const ProfileActions: ProfileActionCreators = bindActionCreators(profileActions, dispatch);
export const FollowActions: typeof followActions = bindActionCreators(followActions, dispatch);
export const CommonActions: typeof commonActions = bindActionCreators(commonActions, dispatch);
export const SettingsActions: typeof settingsActions = bindActionCreators(settingsActions, dispatch);
export const EstimateActions: typeof estimateActions = bindActionCreators(estimateActions, dispatch);
export const SearchActions: typeof searchActions = bindActionCreators(searchActions, dispatch);
export const SeriesActions: typeof seriesActions = bindActionCreators(seriesActions, dispatch);
export const CartActions: typeof cartActions = bindActionCreators(cartActions, dispatch);
export const WishActions: typeof wishActions = bindActionCreators(wishActions, dispatch);
export const OrdersActions: typeof ordersActions = bindActionCreators(ordersActions, dispatch);



// WEBPACK FOOTER //
// ./src/store/actionCreators.js